import { FC, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, SvgIcon, Typography } from '@mui/material';

import { ChevronRightIcon, TicketshopRegionalTicketsIcon } from '../../icons';
import {
	IStyledTicketWrapperProps,
	LogoWrapper,
	StyledTicketWrapper,
} from '../StyledTicketWrapper';

export interface IRegionalTicketsCardProps {
	onClick: MouseEventHandler;
	dataTestId: string;

	// TODO: MC-11977 `notchColor` can be dropped when TicketsList is replaced with Activities
	// Currently needed to fill card indentations with dark color for TicketsList
	notchColor?: IStyledTicketWrapperProps['notchColor'];
}

export const RegionalTicketsCard: FC<IRegionalTicketsCardProps> = ({
	onClick,
	dataTestId,
	notchColor,
}) => {
	const { t } = useTranslation('ticketshop');

	return (
		<StyledTicketWrapper
			dataTestId={`${dataTestId}-ticketshop-regionalTickets-card`}
			onClick={onClick}
			notchColor={notchColor}
			leftSide={
				<LogoWrapper>
					<TicketshopRegionalTicketsIcon />
				</LogoWrapper>
			}
			rightSide={
				<Stack
					height="100%"
					direction="row"
					justifyContent="space-between"
					alignItems="center"
					gap={0.5}
				>
					<Stack gap={0.5}>
						<Typography variant="b1-m" color="primary">
							{t('regional_tickets_card.title')}
						</Typography>
						<Typography variant="l1" color="solutions.600">
							{t('regional_tickets_card.subtitle')}
						</Typography>
					</Stack>
					<SvgIcon color="primary" fontSize="medium">
						<ChevronRightIcon />
					</SvgIcon>
				</Stack>
			}
		/>
	);
};
